export const via_types = [
    { value: 0, label: "公式" },
    { value: 1, label: "一休" },
];
